var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStormNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 204 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter0_f_303_728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.69 53.3063C101.92 62.4993 100.746 75.0453 106.718 85.3905C112.691 95.7358 124.143 100.992 135.49 99.7247C133.077 103 129.954 105.85 126.19 108.023C111.864 116.295 93.6831 111.625 85.5819 97.5936C77.4808 83.5621 82.5274 65.482 96.8537 57.2107C100.617 55.0377 104.647 53.7579 108.69 53.3063Z",
    fill: "#FFEE94"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_303_728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.4934 120C93.9316 123.361 90.3451 130.082 96.4934 130.082C102.642 130.082 99.0552 123.361 96.4934 120Z",
    fill: "#507CB1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_303_728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.3948 113.5C80.833 116.861 77.2465 123.582 83.3948 123.582C89.5431 123.582 85.9566 116.861 83.3948 113.5Z",
    fill: "#507CB1"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_303_728)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.3181,
    y: 107.946,
    width: 49.379,
    height: 7.2011,
    rx: 3.60055,
    fill: "#FFED8D"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_303_728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.29 117.425H118.623L120.926 111.5H111.165L107.29 121.841H114.94L111.398 136L124.29 117.425Z",
    fill: "url(#paint0_linear_303_728)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_303_728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.3259 68.0872C92.3629 67.8674 92.3822 67.6412 92.3822 67.4103C92.3822 65.2507 90.6922 63.5 88.6074 63.5C87.0576 63.5 85.7259 64.4676 85.1446 65.8514C84.6736 65.4302 84.0625 65.1759 83.3946 65.1759C81.9055 65.1759 80.6983 66.4403 80.6983 68C80.6983 68.0869 80.7021 68.1728 80.7094 68.2576C79.9932 68.6211 79.5 69.3836 79.5 70.2655C79.5 71.4996 80.4657 72.5 81.657 72.5H91.843C93.0343 72.5 94 71.4996 94 70.2655C94 69.2034 93.2847 68.3144 92.3259 68.0872Z",
    fill: "url(#paint1_linear_303_728)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_303_728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.38 92.3781C127.548 91.4253 127.636 90.4452 127.636 89.4448C127.636 80.0865 119.944 72.5 110.455 72.5C103.4 72.5 97.3386 76.6928 94.6925 82.6894C92.5488 80.8641 89.7671 79.7621 86.7273 79.7621C79.9492 79.7621 74.4545 85.2412 74.4545 92C74.4545 92.3764 74.4716 92.7488 74.5049 93.1165C71.2448 94.6913 69 97.9957 69 101.817C69 107.165 73.3957 111.5 78.8182 111.5H125.182C130.604 111.5 135 107.165 135 101.817C135 97.2148 131.744 93.3624 127.38 92.3781Z",
    fill: "url(#paint2_linear_303_728)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_303_728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.591 67.5138C137.591 68.1935 137.532 68.8595 137.42 69.5069C140.329 70.1757 142.5 72.7934 142.5 75.9207C142.5 79.5543 139.57 82.5 135.955 82.5H126.132C123.442 76.6047 117.435 72.5 110.455 72.5C105.866 72.5 101.698 74.2736 98.6166 77.1635C98.5401 76.761 98.5 76.3456 98.5 75.9207C98.5 73.324 99.9965 71.0787 102.17 70.0086C102.148 69.7588 102.136 69.5057 102.136 69.25C102.136 64.6575 105.799 60.9345 110.318 60.9345C112.345 60.9345 114.199 61.6833 115.628 62.9236C117.392 58.8489 121.433 56 126.136 56C132.463 56 137.591 61.1549 137.591 67.5138Z",
    fill: "url(#paint3_linear_303_728)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_303_728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.697 63.2073C105.552 61.0831 106.678 59.0553 108.059 57.1802C104.369 57.5924 100.69 58.7606 97.2544 60.7442C89.7763 65.0617 85.0681 72.3069 83.7899 80.1147C84.731 79.8842 85.7148 79.762 86.7273 79.762C89.7671 79.762 92.5488 80.864 94.6924 82.6893C95.6176 80.5928 96.9601 78.7168 98.6166 77.1634C98.5401 76.7609 98.5 76.3455 98.5 75.9206C98.5 73.3239 99.9965 71.0786 102.17 70.0085C102.148 69.7587 102.136 69.5056 102.136 69.2499C102.136 66.8697 103.12 64.7231 104.697 63.2073Z",
    fill: "url(#paint4_linear_303_728)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_303_728",
    x: 28.7167,
    y: 0.306396,
    width: 159.773,
    height: 164.807,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.5,
    result: "effect1_foregroundBlur_303_728"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_303_728",
    x: 93.0986,
    y: 120,
    width: 6.78955,
    height: 13.0815,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_303_728"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_303_728",
    x: 80,
    y: 113.5,
    width: 6.78955,
    height: 13.0815,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_303_728"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_303_728",
    x: 0.318115,
    y: 30.9456,
    width: 203.379,
    height: 161.201,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 38.5,
    result: "effect1_foregroundBlur_303_728"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_303_728",
    x: 105.29,
    y: 111.5,
    width: 19,
    height: 24.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_303_728"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_303_728",
    x: 79.5,
    y: 63.5,
    width: 14.5,
    height: 19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_303_728"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_303_728",
    x: 69,
    y: 72.5,
    width: 66,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_303_728"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_303_728",
    x: 98.5,
    y: 56,
    width: 44,
    height: 36.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_303_728"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_303_728",
    x: 83.7899,
    y: 57.1802,
    width: 24.2694,
    height: 29.509,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_303_728"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_303_728",
    x1: 113.688,
    y1: 133.544,
    x2: 130.106,
    y2: 110.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_303_728",
    x1: 80.4223,
    y1: 71.6964,
    x2: 95.5118,
    y2: 60.9041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.58
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_303_728",
    x1: 73.1979,
    y1: 108.018,
    x2: 139.56,
    y2: 58.1619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.58
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_303_728",
    x1: 139.701,
    y1: 80.1339,
    x2: 94.8549,
    y2: 47.0779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.58
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_303_728",
    x1: 109.405,
    y1: 52.7298,
    x2: 99.5931,
    y2: 112.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEE94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9900"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStormNight);
export default __webpack_public_path__ + "static/media/Storm_Night.f3234c21c35e84635ddd59eba6642ae3.svg";
export { ForwardRef as ReactComponent };